import { AreaChartOutlined, CameraOutlined, CloudOutlined, DashboardOutlined, DeleteOutlined, DeploymentUnitOutlined, FieldTimeOutlined, FileImageOutlined, GroupOutlined, HomeOutlined, NodeIndexOutlined, ShareAltOutlined, SlidersOutlined, TagsOutlined, UsergroupAddOutlined, UserOutlined } from '@ant-design/icons';
import { PATHS } from 'res/routes';

export default {
  route: {
    path: '/',
    routes: [
      {
        path: PATHS.HOME,
        name: 'Dashboard',
        icon: <HomeOutlined />,
      },
      {
        path: PATHS.DATA_USAGE,
        name: 'Data Usage',
        icon: <DashboardOutlined />,
      },
      {
        name: 'Images/Videos',
        icon: <FileImageOutlined />,
        routes: [
          {
            path: '/image/All',
            name: 'My Images',
            icon: <FileImageOutlined />,
          },
          {
            path: '/trash/All',
            name: 'Trash',
            icon: <DeleteOutlined />,
          },
          {
            path: PATHS.IMAGE_TRASH_MORE,
            name: 'Trash Manager',
            icon: <DeleteOutlined />,
          },
          {
            path: PATHS.IMAGE_TAG,
            name: 'Tag Assign',
            icon: <TagsOutlined />,
          },
        ],
      },
      {
        name: 'Camera',
        icon: <CameraOutlined />,
        routes: [
          {
            path: PATHS.CAMERA,
            name: 'Cameras/Map',
            icon: <CameraOutlined />,
          },
          {
            path: PATHS.CAMERA_REMOTE,
            name: 'Remote Control',
            icon: <NodeIndexOutlined />,
          },
          {
            path: PATHS.CAMERA_GROUP,
            name: 'Camera Group',
            icon: <GroupOutlined />,
          },
        ],
      },
      {
        name: 'Sub Accounts',
        icon: <UsergroupAddOutlined />,
        routes: [
          {
            path: PATHS.SUB_CAMERA,
            name: 'Cameras',
            icon: <CameraOutlined />,
          },
          {
            path: '/sub_image/all',
            name: 'Images',
            icon: <FileImageOutlined />,
          },
          {
            path: PATHS.SUB_ACTIVITY,
            name: 'Activity',
            icon: <AreaChartOutlined />,
          },
        ],
      },
      {
        path: PATHS.ACTIVITY,
        name: 'Activity',
        icon: <AreaChartOutlined />,
      },
      // {
      //   path: PATHS.MOVEMENT_MAP,
      //   name: 'Movement Map',
      //   icon: <GlobalOutlined />,
      // },
      {
        path: PATHS.BESTTIME,
        name: 'Best Time',
        icon: <FieldTimeOutlined />,
      },
      {
        name: 'Forecast',
        icon: <CloudOutlined />,
        routes: [
          {
            path: PATHS.WEATHER,
            name: 'Weather',
            icon: <CloudOutlined />,
          },
          {
            path: PATHS.PREDICTION,
            name: 'Prediction',
            icon: <CloudOutlined />,
          },
        ],
      },
      {
        path: PATHS.PROFILE,
        name: 'Profile',
        icon: <UserOutlined />,
      },
      {
        path: PATHS.DETECTION_THRESHOLD,
        name: 'Detection Threshold',
        icon: <SlidersOutlined />,
      },
      {
        name: 'Sharing',
        icon: <ShareAltOutlined />,
        routes: [
          {
            path: PATHS.MANAGE_SHARE,
            name: 'Manage Sharing',
            icon: <CameraOutlined />,
          },
          {
            path: PATHS.SHARED_CAMERA,
            name: 'Shared Cameras',
            icon: <DeploymentUnitOutlined />,
          },
          {
            path: PATHS.SHARE_IMAGE,
            name: 'Shared Images',
            icon: <FileImageOutlined />,
          },
        ],
      },
      // {
      //   path: PATHS.TARGET_PROFILE,
      //   name: 'Target Profile',
      //   icon: <FundOutlined />,
      // },
    ],
  },
  location: {
    pathname: '/',
  },
};
